import React from 'react'

const CloseOfPlay = ({
  cop = []
}) => {
  //temporary, till FE team add class/styles to toolkit
  var liStyle = {
    fontSize:'12px',
    color:'#6c6d6f',
    paddingBottom: '5px'
  }
  var dateStyle = {
    color:'#000',
    fontWeight: 'bold'
  } 
  const content = (
    <article className="sub-module cricket">
      <header className="bordered">
        <h1>Close of Play</h1>
      </header>
    <div className="content">
      <ul>
        {
          cop && cop.map((c = {}, i) => {
            return (
              <li key={i} style={liStyle}>
                <span style={dateStyle}> {c.date}</span> {c.date ? '-' : ''} {c.text}
              </li>
            )
          })
        }
      </ul>
    </div>
  </article>
)

  return cop.length ? content : <article className="sub-module cricket" />
}

export default CloseOfPlay



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/CloseOfPlay.jsx